<template>
  <div class="channel-module">
    <div class="banner cooperation-banner">
      <h1 class="title">
        知链合作伙伴<br
          v-if="$store.state.sceneClassName === 'app'"
        />全国火热招商中
      </h1>
      <p class="desc">满足各行业数字化经营需求，携手知链共拓万亿市场！</p>
      <p class="btn-group">
        <a href="/" target="_blank" class="proxy-btn">我要代理</a>
        <a href="/" target="_blank" class="login-btn">登录渠道CRM</a>
      </p>
    </div>
    <div class="check-channel">
      <div class="channel-search-box">
        <el-input
          placeholder="请输入正确的合作伙伴名称"
          class="input-with-select"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="with-xe">
      <div class="w1200">
        <h2 v-if="$store.state.sceneClassName === 'app'" class="com-title">
          携手知链<br />共掘万亿市场
        </h2>
        <h2 v-else class="com-title">
          携手知链&nbsp;&nbsp;&nbsp;共掘万亿市场
        </h2>
        <ul class="data">
          <li><big>130万</big>注册客户</li>
          <li>覆盖<big>6.8亿</big>终端用户</li>
          <li>客户总流水<big>110亿元</big></li>
          <li><big>1500万</big>个知识商品</li>
        </ul>
        <ul class="channelImprove">
          <li>
            <div class="icon-icon_cooperation">
              <img :src="require('@/assets/images/icon_1.svg')" alt="" />
            </div>
            <div>
              <h3>SaaS服务</h3>
              <p class="desc">零门槛搭建在线网校，教育机构转型线上的首选工具</p>
              <p class="sub-desc">
                包含新教育、知识付费、直播、会议系统、打卡等
              </p>
            </div>
          </li>
          <li>
            <div class="icon-icon_cooperation">
              <img :src="require('@/assets/images/icon_4.svg')" alt="" />
            </div>
            <div>
              <h3>PaaS服务</h3>
              <p class="desc">
                低门槛云开发，共享核心能力专注教培行业的PaaS服务
              </p>
              <p class="sub-desc">
                包含知链应用市场、API自主开发、个性定制服务
              </p>
            </div>
          </li>
          <li>
            <div class="icon-icon_cooperation">
              <img :src="require('@/assets/images/icon_2.svg')" alt="" />
            </div>
            <div>
              <h3>流量服务</h3>
              <p class="desc">拥有业界最大的流量置换市场，精准联结内容与流量</p>
              <p class="sub-desc">包含内容分销、广告分发等</p>
            </div>
          </li>
          <li>
            <div class="icon-icon_cooperation">
              <img :src="require('@/assets/images/icon_3.svg')" alt="" />
            </div>
            <div>
              <h3>商家服务</h3>
              <p class="desc">
                行业大咖亲授，扶持中小型教育机构更快上手线上业务
              </p>
              <p class="sub-desc">包含商家学院、资源对接等</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="cooperation">
      <div class="w1200">
        <h2 class="com-title">合作优势</h2>
        <ul class="help-items">
          <li>
            <div class="help-item">
              <div class="help-plan-title title1">丰厚返利</div>
              <div class="help-plab-desc">
                <p>高回报返利体系</p>
                <p>高续费比例带来稳定营收</p>
                <p>季/年度优秀代理商激励</p>
              </div>
            </div>
          </li>
          <li>
            <div class="help-item">
              <div class="help-plan-title title2">体系化培训</div>
              <div class="help-plab-desc">
                <p>定期线上产品培训</p>
                <p>定期线下新兵训练营</p>
                <p>渠道经理定期走访辅导</p>
              </div>
            </div>
          </li>
          <li>
            <div class="help-item">
              <div class="help-plan-title title3">市场支持</div>
              <div class="help-plab-desc">
                <p>产品画册、四折页等物料</p>
                <p>专属授权服务商挂牌</p>
                <p>拓客话术等销售资料</p>
              </div>
            </div>
          </li>
          <li>
            <div class="help-item">
              <div class="help-plan-title title4">服务支持</div>
              <div class="help-plab-desc">
                <p>7*12小时在线人工客服</p>
                <p>专属代理商服务沟通群</p>
                <p>专属客户沟通服务群</p>
              </div>
            </div>
          </li>
          <li>
            <div class="help-item">
              <div class="help-plan-title title5">驻地支持</div>
              <div class="help-plab-desc">
                <p>线下交流和沙龙</p>
                <p>运营能力培训服务</p>
                <p>市场销售集训服务</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="requirement pt96 pb72">
      <div class="com-title mb80">合作条件</div>
      <div class="w1200">
        <ul class="require-list">
          <li class="require-item">
            <div class="iconfont EC1 iconicon_culture"></div>
            <div class="title T5 EC2 mb8">认可知链文化</div>
            <p class="desc T7 EC3">认同知链产品价值和文化理念</p>
            <p class="desc T7 EC3">愿意跟知链长期合作</p>
          </li>
          <li class="require-item">
            <div class="iconfont EC1 iconicon_company"></div>
            <div class="title T5 EC2 mb8">具有公司资质</div>
            <p class="desc T7 EC3">有合作营业执照和独立法人代表</p>
            <p class="desc T7 EC3">有良好商业信誉和口碑</p>
          </li>
          <li class="require-item">
            <div class="iconfont EC1 iconicon_industry"></div>
            <div class="title T5 EC2 mb8">具有行业背景</div>
            <p class="desc T7 EC3">有互联网背景</p>
            <p class="desc T7 EC3">对教育行业、SaaS行业有了解</p>
          </li>
          <li class="require-item">
            <div class="iconfont EC1 iconicon_saleschannel"></div>
            <div class="title T5 EC2 mb8">具有客户资源</div>
            <p class="desc T7 EC3">拥有当地丰富的企业及资源</p>
            <p class="desc T7 EC3">或教育机构/老师资源</p>
          </li>
          <li class="require-item">
            <div class="iconfont EC1 iconicon_sales"></div>
            <div class="title T5 EC2 mb8">具有销售团队</div>
            <p class="desc T7 EC3">有专属且成熟的销售团队</p>
            <p class="desc T7 EC3">负责人有团队管理经验</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="agency">
      <div class="w1200">
        <h2 class="com-title">知链合作伙伴申请流程</h2>
        <ul class="channelProces">
          <li>
            <div class="iconfont icontujiaoshenqing"></div>
            <p class="dot"></p>
            <span>提交申请</span>
          </li>
          <li>
            <div class="iconfont iconshenheziliao"></div>
            <p class="dot"></p>
            <span>审核资料</span>
          </li>
          <li>
            <div class="iconfont iconhezuoqietan"></div>
            <p class="dot"></p>
            <span>洽谈合作</span>
          </li>
          <li>
            <div class="iconfont iconqiandinghetong"></div>
            <p class="dot"></p>
            <span>签约合作</span>
          </li>
        </ul>
        <div class="line">
          <i class="iconfont"></i>
        </div>
        <a
          href="https://partner.getchain.cn/join"
          data-count="pc-渠道合作_合作流程_立即申请"
          data-sensors="渠道合作页_渠道合作_合作流程-立即申请"
          target="_blank"
          class="agency-btn"
          >立即申请</a
        >
        <p class="agency-phone">咨询热线：18205970111</p>
      </div>
    </div>
    <div class="outlook">
      <h2 class="com-title">知链优秀合作伙伴评价</h2>
      <div class="w1200">
        <div
          v-if="$store.state.sceneClassName === 'app'"
          class="outlook-swiper"
        >
          <div class="swiper-pagination"></div>
          <swiper :options="swiperOptions">
            <swiper-slide v-for="item in 4" :key="`cmb_${item}`">
              <img
                :src="require('@/assets/images/img_cooperation1.png')"
                class="outlook-img"
                alt=""
              />
              <div class="text">
                <p class="title">东莞某代理商</p>
                <p class="desc">
                  "从知链客户发展为知链代理商，我已经是它的铁粉了。知链好用，帮助机构降低技术人员的成本，行业口碑也好，所以创业的时候，我义无反顾把知链代理上了。"
                </p>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <ul v-else class="outlook-list">
          <li class="outlook-item">
            <img
              :src="require('@/assets/images/img_cooperation1.png')"
              class="outlook-img"
              alt=""
            />
            <div class="text">
              <p class="title">广州某代理商</p>
              <p class="desc">
                "这几年，二三线城市的教育机构非常多，当身边朋友都在扎堆代理母婴、建材产品，我反倒觉得代理教育产品更能赚到钱。到现在，家乡的教育机构基本都用上知链。"
              </p>
            </div>
          </li>
          <li class="outlook-item">
            <img
              :src="require('@/assets/images/img_cooperation2.png')"
              class="outlook-img"
              alt=""
            />
            <div class="text">
              <p class="title">东莞某代理商</p>
              <p class="desc">
                "从知链客户发展为知链代理商，我已经是它的铁粉了。知链好用，帮助机构降低技术人员的成本，行业口碑也好，所以创业的时候，我义无反顾把知链代理上了。"
              </p>
            </div>
          </li>
          <li class="outlook-item">
            <img
              :src="require('@/assets/images/img_cooperation3.png')"
              class="outlook-img"
              alt=""
            />
            <div class="text">
              <p class="title">北京某代理商</p>
              <p class="desc">
                "今年9月开始合作，在渠道的大力帮扶下，首月业绩高达20多万。我相信知链一定会为教育行业创造巨大的价值！"
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination } from 'swiper';
SwiperCore.use([Pagination]);
export default {
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        watchSlidesProgress: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  }
};
</script>

<style lang="scss">
.channel-module {
  .cooperation-banner {
    height: 612px;
    background: url('~@/assets/images/channel1.png') center center no-repeat;
    background-size: cover;
    padding-top: 232px;
    color: #fff;
    text-align: center;
  }
  .cooperation-banner .title {
    font-size: 64px;
    line-height: 72px;
    letter-spacing: 2px;
    margin-bottom: 32px;
  }
  .cooperation-banner .desc {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 72px;
  }
  .cooperation-banner .btn-group {
    font-size: 14px;
  }
  .cooperation-banner .btn-group a {
    display: inline-block;
    width: 144px;
    height: 44px;
    line-height: 44px;
    border: 1px solid transparent;
    border-radius: 22px;
    text-align: center;
  }
  .cooperation-banner .btn-group .proxy-btn {
    margin-right: 32px;
    background-color: #fff;
    color: #1472ff;
  }
  .cooperation-banner .btn-group .proxy-btn:hover {
    background: #3d91ff;
    color: #fff;
  }
  .cooperation-banner .btn-group .login-btn {
    border-color: #fff;
    color: #fff;
  }
  .with-xe {
    padding-top: 80px;
    padding-bottom: 120px;
    background: url('~@/assets/images/channel3.png') center bottom no-repeat;
  }
  .with-xe .data {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    margin-bottom: 44px;
  }
  .with-xe .data li {
    margin: 0 10px;
    font-size: 18px;
    color: #333;
  }
  .with-xe .data li big {
    font-size: 20px;
    font-weight: 700;
  }
  .channelImprove {
    display: flex;
    justify-content: space-between;
    text-align: center;
  }
  .help-items,
  .require-list {
    align-items: center;
    display: flex;
  }
  .channelImprove li {
    width: 282px;
    height: 362px;
    padding: 40px;
    background: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
  }
  .agency,
  .cooperation {
    padding-bottom: 120px;
  }
  .channelImprove li h3 {
    font-size: 18px;
    color: #353535;
    margin-bottom: 20px;
  }
  .channelImprove li .desc {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .channelImprove li .sub-desc {
    width: 180px;
    margin: 0 auto;
    color: #666;
    line-height: 20px;
    font-size: 14px;
  }
  .channelImprove li .icon-icon_cooperation {
    margin-bottom: 10px;
  }
  .cooperation {
    padding-top: 80px;
    background-color: #f5f6f9;
    background-image: url('~@/assets/images/channel2.png');
  }
  .help-items {
    justify-content: space-between;
    margin-top: 67px;
  }
  .help-items li {
    width: 221px;
    height: 245px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    text-align: center;
    padding-top: 8px;
    &:nth-of-type(1) {
      background: linear-gradient(
        90deg,
        rgba(255, 139, 64, 1) 0%,
        rgba(255, 54, 14, 1) 100%
      );
      .help-plan-title {
        color: #ff6419;
      }
    }
    &:nth-of-type(2) {
      background: linear-gradient(
        90deg,
        rgba(235, 46, 46, 1) 0%,
        rgba(253, 64, 154, 1) 100%
      );
      .help-plan-title {
        color: #e53232;
      }
    }
    &:nth-of-type(3) {
      background: linear-gradient(
        90deg,
        rgba(32, 53, 255, 1) 0%,
        rgba(36, 194, 255, 1) 100%
      );
      .help-plan-title {
        color: #105cfb;
      }
    }
    &:nth-of-type(4) {
      background: linear-gradient(
        90deg,
        rgba(53, 228, 226, 1) 0%,
        rgba(56, 217, 134, 1) 100%
      );
      .help-plan-title {
        color: #2fbb7c;
      }
    }
    &:nth-of-type(5) {
      background: linear-gradient(
        90deg,
        rgba(255, 116, 47, 1) 0%,
        rgba(255, 194, 68, 1) 100%
      );
      .help-plan-title {
        color: #ffb13f;
      }
    }
  }
  .help-items li .help-item {
    height: 237px;
    background: #fff;
  }
  .help-items li .help-plan-title {
    height: 113px;
    line-height: 113px;
    font-size: 24px;
    text-align: center;
  }
  .help-items li .help-plab-desc p {
    line-height: 28px;
    color: #333;
    font-size: 14px;
  }
  .require-list {
    justify-content: space-between;
  }
  .require-list .require-item {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .require-list .require-item .iconfont {
    font-size: 40px;
    margin-bottom: 20px;
  }
  .require-list .require-item .desc {
    line-height: 20px;
  }
  .agency {
    background: #f5f6f9;
    padding-top: 80px;
    text-align: center;
  }
  .agency .agency-btn {
    margin-top: 80px;
    display: inline-block;
    width: 160px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    background: #1472ff;
    border-radius: 24px;
    font-size: 16px;
  }
  .agency .agency-btn:hover {
    background: #3f83ee;
  }
  .agency .agency-phone {
    margin-top: 32px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .channelProces {
    width: 100%;
    margin-top: 70px;
  }
  .channelProces:after {
    content: '';
    width: 100%;
    clear: both;
    display: block;
  }
  .channelProces li {
    width: 25%;
    float: left;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 45px;
    text-align: center;
    box-sizing: border-box;
  }
  .channelProces li .dot {
    width: 12px;
    height: 12px;
    background: #999;
    border-radius: 50%;
    margin-bottom: 16px;
  }
  .channelProces li div {
    width: 120px;
    height: 120px;
    font-size: 48px;
    background: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }
  .channelProces li span {
    font-size: 16px;
    color: #333;
  }
  .line {
    height: 0;
    border-top: 1px dashed #979797;
    position: relative;
    bottom: 43px;
  }
  .outlook {
    padding: 92px 0 124px;
  }
  .outlook .outlook-list {
    display: flex;
    justify-content: space-between;
    margin-top: 42px;
  }
  .outlook .outlook-list .outlook-item {
    width: 373px;
    height: 424px;
    background: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.08);
  }
  .outlook .outlook-list .outlook-item .outlook-img {
    width: 373px;
    height: 200px;
  }
  .outlook .outlook-list .outlook-item .text {
    padding: 30px 26px;
  }
  .outlook .outlook-list .outlook-item .title {
    font-size: 20px;
    color: #353535;
    line-height: 28px;
    margin-bottom: 14px;
  }
  .outlook .outlook-list .outlook-item .desc {
    font-size: 16px;
    color: #666;
    line-height: 24px;
  }
  .check-channel {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    background-color: #f4f9ff;
  }
  .check-channel .channel-search-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 800px;
  }
  .check-channel .channel-search-box input {
    padding-right: 100px;
    width: 800px;
    height: 64px;
    line-height: 64px;
    text-indent: 22px;
    border: none;
    outline: 0;
    font-size: 16px;
    border-radius: 32px;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  }
  .check-channel .channel-search-box ::-webkit-input-placeholder {
    color: #b2b2b2;
  }
  .check-channel .channel-search-box :-moz-placeholder {
    color: #b2b2b2;
  }
  .check-channel .channel-search-box ::-moz-placeholder {
    color: #b2b2b2;
  }
  .check-channel .channel-search-box :-ms-input-placeholder {
    color: #b2b2b2;
  }
  .check-channel .channel-search-box input::-ms-reveal {
    display: none;
  }
  .check-channel .channel-search-box input::-ms-clear {
    display: none;
  }
  .check-channel .channel-search-box .el-input-group__append {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    width: 84px;
    height: 64px;
    background: #1472ff;
    border-color: #1472ff;
    border-radius: 0 100px 100px 0;
    i {
      font-size: 28px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .check-channel .channel-search-box .channel-search {
    margin-left: -5px;
    width: 20px;
  }
  .com-title {
    font-size: 32px;
    color: #333;
    font-weight: 400;
    text-align: center;
  }
}
.app .channel-module {
  padding-top: 1.04rem;
  .cooperation-banner {
    height: auto;
    padding-top: 0.96rem;
    padding-bottom: 1.52rem;
    background: url('~@/assets/images/channel1_app.png') center center no-repeat;
    background-size: cover;
    color: #fff;
    .title {
      margin-bottom: 0;
      font-size: 0.8rem;
      line-height: 1.12rem;
      font-weight: 600;
    }
    .desc {
      margin: 0.24rem auto 0.48rem;
      width: 5.6rem;
      line-height: 0.48rem;
      font-size: 0.32rem;
    }
    .btn-group {
      flex-direction: column;
      align-items: center;
      a {
        margin: 0 auto 0.48rem;
        width: 3.2rem;
        height: 0.88rem;
        line-height: 0.88rem;
        border-radius: 0.55rem;
        border-width: 0.02rem;
        font-size: 0.28rem;
      }
    }
  }
  .check-channel {
    height: 1.52rem;
    .channel-search-box {
      width: auto;
      box-shadow: 0 0.16rem 0.48rem 0 rgba(0, 0, 0, 0.08);
      border-radius: 0.64rem;
      input {
        width: 6.86rem;
        height: 0.88rem;
        line-height: 0.88rem;
        text-indent: 0.2rem;
        font-size: 0.28rem;
        border-radius: 0.64rem;
      }
      .el-input-group__append {
        width: 1.68rem;
        height: 0.88rem;
        border-radius: 0 2rem 2rem 0;
        i {
          font-size: 0.4rem;
        }
      }
    }
  }
  .with-xe {
    padding: 1.6rem 0.48rem;
    .data {
      flex-wrap: wrap;
      margin: 0.24rem 0 0;
      li {
        width: 50%;
        text-align: left;
        font-size: 0.32rem;
        line-height: 0.5rem;
        margin: 0;
        big {
          font-size: 0.36rem;
          font-weight: normal;
        }
      }
    }
  }
  .com-title {
    font-size: 0.56rem;
    line-height: 0.8rem;
    font-weight: bold;
  }
  .channelImprove {
    display: block;
    li {
      width: 6.54rem;
      height: 7rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.08);
      padding: 0.82rem 1.26rem 0.56rem;
      margin-top: 0.88rem;
      .icon-icon_cooperation {
        margin: 0 auto 0.62rem;
        width: 2rem;
        height: 2rem;
      }
      h3 {
        font-size: 0.36rem;
        color: #353535;
        margin-bottom: 0.46rem;
      }
      .desc {
        font-size: 0.32rem;
        color: #333;
        line-height: 0.44rem;
        margin-bottom: 0.16rem;
      }
      .sub-desc {
        font-size: 0.28rem;
        color: #666;
        line-height: 0.4rem;
      }
    }
  }
  .cooperation {
    padding: 1.5rem 0.92rem 1.12rem;
    background: #f5f6f9;
  }
  .help-items {
    display: block;
    margin-top: 0.66rem;
    li {
      width: 5.64rem;
      height: 4.9rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.02),
        0 0.4rem 0.8rem 0 rgba(0, 0, 0, 0.04);
      border-radius: 0.08rem;
      padding-top: 0.16rem;
      margin: 0 0 0.48rem;
      .help-item {
        height: 4.74rem;
        .help-plan-title {
          height: 2.26rem;
          line-height: 2.26rem;
          font-size: 0.48rem;
        }
        .help-plab-desc p {
          line-height: 0.56rem;
          font-size: 0.32rem;
        }
      }
    }
  }
  .requirement {
    padding: 1.6rem 1.14rem 0.32rem;
    .require-list {
      display: block;
      .require-item {
        position: relative;
        text-align: left;
        padding-left: 1.04rem;
        margin-bottom: 1.28rem;
        display: block;
        .iconfont {
          position: absolute;
          left: 0;
          top: 0;
          font-size: 0.8rem;
          margin-bottom: 0;
        }
        .title {
          font-size: 0.4rem;
          margin-bottom: 8px;
        }
        .desc {
          font-size: 14px;
          line-height: 0.4rem;
          color: #666;
        }
      }
    }
  }
  .agency {
    padding: 1.6rem 0;
    .channelProces {
      padding: 0.8rem 1.54rem 0.5rem;
      margin: 0;
      &::after {
        display: none;
      }
      li {
        width: auto;
        float: none;
        flex-direction: row;
        margin-bottom: 0.8rem;
        padding: 0;
        .dot {
          display: none;
        }
        div {
          width: 2.16rem;
          height: 2.16rem;
          font-size: 0.86rem;
          margin-right: 0.48rem;
          margin-bottom: 0;
        }
        span {
          font-size: 0.36rem;
        }
        &:not(:last-child)::after {
          content: '';
          position: absolute;
          width: 0;
          height: 0.8rem;
          border-left: 0.04rem dashed #979797;
          bottom: -0.8rem;
          left: 1.08rem;
        }
      }
    }
    .line {
      display: none;
    }
    .agency-btn {
      width: 3.2rem;
      height: 0.96rem;
      line-height: 0.96rem;
      margin: 0;
      font-size: 0.32rem;
      border-radius: 0.5rem;
    }
    .agency-phone {
      margin-top: 0.48rem;
      font-size: 0.4rem;
      font-family: inherit;
    }
  }
  .outlook {
    padding: 1.6rem 0 1rem;
    .outlook-swiper {
      position: relative;
      overflow: hidden;
      margin-top: 1.28rem;
      padding-bottom: 1.2rem;
      .swiper-pagination-bullets {
        bottom: 10px;
        left: 0;
        width: 100%;
        .swiper-pagination-bullet {
          margin: 0 5px;
        }
      }
    }
    .swiper-slide {
      width: 6.54rem;
      height: 7.98rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.02),
        0 0.4rem 0.8rem 0 rgba(0, 0, 0, 0.04);
      border-radius: 0.08rem;
      background-color: #fff;
      transform-style: preserve-3d;
      position: relative;
      text-align: center;
      img {
        max-width: 100%;
      }
      .text {
        text-align: left;
        padding: 0.4rem;
        .title {
          font-size: 0.4rem;
          color: #353535;
          margin-bottom: 0.24rem;
        }
        .desc {
          font-size: 0.32rem;
          line-height: 0.48rem;
          color: #666;
        }
      }
    }
    .swiper-container {
      overflow: visible;
    }
  }
}
</style>
